import { UserBooking } from "../../types/responseTypes";

async function getUserBookings(): Promise<UserBooking[]> {
  try {
    const url = `https://ruuf-backend.online/booking/get-user-bookings`;
    const timeout = new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    const userBookings: UserBooking[] = await response.json();

    if (response.status === 200) {
      console.log("User bookings fetched successfully");
      // Filter out any null entries
      return userBookings.filter(
        (booking: UserBooking | null) => booking !== null,
      );
    } else if (response.status === 502) {
      console.error("Invalid cookie: Error fetching user bookings");
      return [];
    } else {
      throw new Error("Could not fetch user bookings");
    }
  } catch (error) {
    console.error("Error fetching user bookings:", error);
    return [];
  }
}

export default getUserBookings;
